/**
 * Generación de rutas por idioma a partir de UNA sola lista de definiciones.
 *
 * El español conserva las rutas sin prefijo (incluido el alias `/envio-receta`
 * del QR impreso) y el resto de idiomas obtiene el mismo árbol bajo `/en`,
 * `/fr`, `/pt`. Se usan rutas estáticas por idioma (no `/:lang/*`) para que un
 * prefijo desconocido como `/de/recetas` no se interprete como idioma y
 * siga sin coincidir con ninguna ruta, igual que antes.
 */

import React from 'react';
import { Route } from 'react-router-dom';
import { PREFIXED_LANGUAGES } from './languages';
import { localizePath } from './paths';

/**
 * @typedef {Object} RouteDefinition
 * @property {string} path - Ruta en español, con `/` inicial (`/`, `/recetas/:slug`).
 * @property {React.ReactElement} element - Página a renderizar.
 */

/**
 * Devuelve la lista plana de <Route> para español y para cada idioma con prefijo.
 * React Router v6 acepta arrays de <Route> como hijos de <Routes>.
 * @param {RouteDefinition[]} definitions - Definiciones de rutas (fuente única).
 * @returns {React.ReactElement[]} Rutas listas para <Routes>
 */
const renderLocalizedRoutes = (definitions) => {
  const languages = ['es', ...PREFIXED_LANGUAGES];
  return languages.flatMap((lang) =>
    definitions.map(({ path, element }) => (
      <Route key={`${lang}:${path}`} path={localizePath(path, lang)} element={element} />
    ))
  );
};

export default renderLocalizedRoutes;
